import http from '@/http'

const upload = file => {
	const path = `/media_objects`

	const headers = {
		'Content-Type': 'multipart/form-data'
	}

	return http.post(path, file, { headers })
}

const uploadDocument = file => {
	const path = `/media_objects/documents`
	const headers = {
		'Content-Type': 'multipart/form-data'
	}

	return http.post(path, file, { headers })
}

const deleteImage = image => {
	// Extract ID from @id if available, otherwise use id directly
	let imageId
	if (image['@id']) {
		// @id format: /api/media_objects/123
		imageId = image['@id'].split('/').pop()
	} else if (image.id) {
		imageId = image.id
	} else {
		return Promise.reject(new Error('Image ID not found'))
	}

	const path = `/media_objects/${imageId}`
	return http.delete(path)
}

export default {
	upload,
	uploadDocument,
	deleteImage
}
